import React, { Component } from 'react';
import classNames from 'classnames';
import { Menu } from 'antd';
import styles from './AntMenu.scss';

const { Item, SubMenu, Divider } = Menu;

class AntMenuItem extends Component {
  render() {
    const { className } = this.props;
    const itemClass = classNames(className, {
      [`${styles['menu-item']}`]: true,
    });
    return (
      <Item {...this.props} className={itemClass}/>
    );
  }
}

class AntSubMenu extends Component {
  render() {
    const { className } = this.props;
    const subClass = classNames(className, {
      [`${styles['sub-menu']}`]: true,
    });
    return (
      <SubMenu {...this.props} className={subClass}/>
    );
  }
}

class AntDivider extends Component {
  render() {
    const { className } = this.props;
    const dividerClass = classNames(className, {
      [`${styles['menu-divider']}`]: true,
    });
    return (
      <Divider {...this.props} className={dividerClass}/>
    );
  }
}

export default class AntMenu extends Component {
  static ItemGroup = Menu.ItemGroup;
  static Divider = AntDivider;
  static Item = AntMenuItem;
  static SubMenu = AntSubMenu;

  render() {
    const { className } = this.props;
    const menuClass = classNames(className, {
      [`${styles['menu']}`]: true,
    });
    return (
      <Menu {...this.props} className={menuClass}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AntMenu/AntMenu.js